var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"popover",staticClass:"popover",style:(`top:${_vm.getPopoverTop}px;left:${_vm.getPopoverLeft}px;opacity:${_vm.visible ? 100 : 0}`)},[_c('div',{staticClass:"wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }